/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationDetails {
    getFixupPrototypeFunction() { return UtilizationDetails.fixupPrototype; }

    static newInstance(model: Partial<UtilizationDetails>): UtilizationDetails {
        let obj = Object.assign(new UtilizationDetails(), model);
        UtilizationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationDetails>): UtilizationDetails {
        if (!model) return null;
        return UtilizationDetails.newInstance(<UtilizationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationDetails) {
        if (!obj) return;

        models.UtilizationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationDetails): boolean {
        Object.setPrototypeOf(obj, UtilizationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Day wise utilization
     */
    date: string;

    /**
     * Utilization by percentage for that date
     */
    percentage: number;

}
